export default __webpack_public_path__ + "static/media/close-white.5c949b04.svg";